import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'recompose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import {
  STORE_KEY_VIDEO_PLAYER_COMMENTS_TOOL_TIP,
} from '../../services/store-keys/index'
import VideoPlayerMeta from '../VideoPlayerMeta/index'
import VideoPlayerBack from '../VideoPlayerBack/index'

class VideoPlayerApp extends Component {
  componentDidUpdate () {
    if (!process.env.BROWSER) {
      return
    }

    const { videoPlayer, toolTip, setToolTipVisible } = this.props
    const videoLoading = videoPlayer.get('loading', null)
    const commentsToolTipVisible = toolTip.getIn(
      [STORE_KEY_VIDEO_PLAYER_COMMENTS_TOOL_TIP, 'visible'],
      null,
    )

    if (
      videoLoading === false
      && toolTip.get('initializedFeatureTracking')
      && commentsToolTipVisible === null
    ) {
      setToolTipVisible(STORE_KEY_VIDEO_PLAYER_COMMENTS_TOOL_TIP, true)
    }
  }

  pausePlayer = () => {
    const { props } = this
    const { player } = props
    if (!player) {
      return
    }
    try {
      player.pause()
    } catch (e) {
      // Do nothing player errored
    }
  }

  playPlayer = () => {
    const { props } = this
    const { player } = props
    if (!player) {
      return
    }
    try {
      player.play()
    } catch (e) {
      // Do nothing player errored
    }
  }

  isPlaying = () => {
    const { props } = this
    const { player } = props
    if (!player) {
      return false
    }
    return !player.paused()
  }

  playerPlayOrPause = () => {
    const { props } = this
    const { player } = props
    if (!player) return
    try {
      if (player.paused()) {
        player.play()
        return
      }
      player.pause()
    } catch (e) {
      // Do nothing player call failed
    }
  }

  render () {
    const {
      props,
      pausePlayer,
      playerPlayOrPause,
      playPlayer,
      isPlaying,
    } = this
    const {
      location,
      video,
      videoPlayer,
      history,
      primaryCourse,
    } = props
    const {
      setVideoPlayerMetaAutoHide,
      toggleVideoPlayerMetaMoreVisible,
    } = props
    const metaAutoHide = videoPlayer.get('metaAutoHide', true)
    const metaVisible = videoPlayer.get('metaVisible', true)
    const metaMoreVisible = videoPlayer.get('metaMoreVisible', true)
    const metaVotesVisible = videoPlayer.get('metaVotesVisible', false)

    const isGuide = video.getIn(['data', 'contentSubtype']) === 'guide'
      || video.getIn(['data', 'displayType']) === 'guide'
      || video.getIn(['data', 'productType']) === 'guide'

    const videoContentId = video.getIn(['data', 'id'])
    const videoContentTitle = video.getIn(['data', 'title'])
    const geoAvailibility = video.getIn(
      ['data', 'feature', 'georestrictions', 'availability'],
      '',
    )
    const canRenderVideoPlayerMeta = videoContentId != null && videoContentTitle != null

    return (
      <div
        className={`video-player-app${metaVisible ? ' video-player-app--visible' : ''}`}
        style={{ pointerEvents: 'none' }}
      >
        <div className="video-player-app__controls" style={{ pointerEvents: 'none' }}>
          <div className="video-player-app__interactive" style={{ pointerEvents: 'auto' }}>
          <VideoPlayerBack
            history={history}
            location={location}
            visible={metaVisible}
            videoUrl={video.get('path')}
          />
          {canRenderVideoPlayerMeta ? (
            <VideoPlayerMeta
              id={videoContentId}
              title={videoContentTitle}
              series={video.getIn(['data', 'seriesTitle'])}
              seriesId={video.getIn(['data', 'seriesId'])}
              mediaId={video.getIn(['data', 'feature', 'id'])}
              mediaLang={video.getIn(['data', 'videoLang'])}
              host={video.getIn(['data', 'host'])}
              season={video.getIn(['data', 'season'])}
              episode={video.getIn(['data', 'episode'])}
              duration={video.getIn(['data', 'feature', 'duration'])}
              contentType={video.getIn(['data', 'type', 'content'])}
              description={video.getIn(['data', 'description'])}
              geoAvailibility={geoAvailibility}
              visible={metaVisible}
              autoHide={metaAutoHide}
              moreVisible={metaMoreVisible}
              toggleMoreVisible={toggleVideoPlayerMetaMoreVisible}
              setAutoHide={setVideoPlayerMetaAutoHide}
              playerPause={pausePlayer}
              playerPlay={playPlayer}
              playerPlayOrPause={playerPlayOrPause}
              isPlaying={isPlaying}
              isGuide={isGuide}
              votesVisible={metaVotesVisible}
              primaryCourse={primaryCourse}
            />
          ) : null}
          </div>
        </div>
      </div>
    )
  }
}

VideoPlayerApp.propTypes = {
  showToolTips: PropTypes.bool,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  player: PropTypes.object.isRequired,
  commentsVisible: PropTypes.bool.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  comments: ImmutablePropTypes.map.isRequired,
  video: ImmutablePropTypes.map.isRequired,
  videoPlayer: ImmutablePropTypes.map.isRequired,
  toolTip: ImmutablePropTypes.map.isRequired,
  setCommentsVisible: PropTypes.func.isRequired,
  refreshComments: PropTypes.func.isRequired,
  toggleVideoPlayerMetaMoreVisible: PropTypes.func.isRequired,
  setToolTipVisible: PropTypes.func.isRequired,
  setToolTipVisiblePersistent: PropTypes.func.isRequired,
  setVideoPlayerMetaAutoHide: PropTypes.func.isRequired,
  setVideoPlayerMetaMoreVisible: PropTypes.func.isRequired,
  setFeatureTrackingDataPersistent: PropTypes.func,
  staticText: ImmutablePropTypes.map.isRequired,
  primaryCourse: ImmutablePropTypes.map,
}

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      comments: state.comments,
      video: state.video,
      videoPlayer: state.videoPlayer,
      toolTip: state.toolTip,
      staticText: state.staticText.getIn(['data', 'videoPlayerApp']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setCommentsVisible: actions.comments.setCommentsVisible,
        refreshComments: actions.comments.refreshComments,
        toggleVideoPlayerMetaMoreVisible:
          actions.videoPlayer.toggleVideoPlayerMetaMoreVisible,
        setVideoPlayerMetaAutoHide:
          actions.videoPlayer.setVideoPlayerMetaAutoHide,
        setVideoPlayerMetaMoreVisible:
          actions.videoPlayer.setVideoPlayerMetaMoreVisible,
        setToolTipVisible: actions.toolTip.setToolTipVisible,
        setToolTipVisiblePersistent: actions.toolTip.setToolTipVisiblePersistent,
        setFeatureTrackingDataPersistent:
          actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
)(VideoPlayerApp)
